import { SvgIcon, SvgIconProps } from "@mui/material";

export const WhyCreateGroupButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.87513 14.1248L14.1247 5.87519M14.1247 5.87519L7.05364 5.87519M14.1247 5.87519L14.1247 12.9463"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const ModalCloseButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "21", height: "24", fill: "none" }}
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
    >
      <path
        d="M14.875 7L6.125 17M6.125 7L14.875 17"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const UploadGroupAvatarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "26", height: "26", fill: "none" }}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <rect x="1" y="0.5" width="24.3333" height="24.3333" rx="12.1667" fill="#008B07" />
      <rect x="1" y="0.5" width="24.3333" height="24.3333" rx="12.1667" stroke="white" />
      <path
        d="M15.6057 7.32745C16.2643 6.66884 17.3319 6.66884 17.9905 7.32745L18.5061 7.84308C19.1644 8.50172 19.1646 9.56932 18.5061 10.2278L10.886 17.847L7.3645 18.4681L7.9856 14.9466L15.6057 7.32745Z"
        fill="white"
        stroke="#008B07"
      />
    </SvgIcon>
  );
};

export const SearchGroupMembersFieldIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 21L16.65 16.65M11 6C13.7614 6 16 8.23858 16 11M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
        stroke="#707070"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ArrowBackButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M15 19L7 11L15 3" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};
